export default __webpack_public_path__ + "media/images/corp/bottom_frame2-c725dd606c2dc63c742b0c2401a86ce9.png";